import { Grid, Typography } from '@material-ui/core';
import DropdownMenu, { IOption } from 'components/Shared/DropdownMenu';
import { WithStyles } from 'decorators/withStyles';
import { IOrderBump } from 'interfaces/orderbump';
import EditIcon from 'mdi-react/EditIcon';
import PowerStandbyIcon from 'mdi-react/PowerStandbyIcon';
import React, { Component } from 'react';
import ProductInfo from './ProductInfo';

interface IProps {
  key: number;
  classes?: any;
  orderbump?: IOrderBump;
  handleRegister: (orderBump: IOrderBump) => void;
  powerOrderBump: (orderBump: IOrderBump) => void;
}

interface IState {}

@WithStyles(() => ({
  expansionPanel: {
    padding: '8px 13px',
    margin: '10px 0',
    border: '1px solid #ccc',
    borderRadius: 7,
    transition: '0.2s ease-in-out',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:hover': {
      boxShadow: '1px 1px 5px 2px #ccc'
    },
    '& p': {
      color: '#8E8E8E',
      alignSelf: 'center',
      fontSize: '16px',
      letterSpacing: '0.44px',
      padding: '0 8px',
      lineHeight: '16px'
    }
  }
}))
export default class RowList extends Component<IProps, IState> {
  render() {
    const { orderbump, handleRegister, powerOrderBump } = this.props;
    const { expansionPanel } = this.props.classes;
    const options: IOption[] = [
      { text: 'Editar', icon: () => <EditIcon />, handler: params => handleRegister(params) },
      { text: 'Ligar/Desligar', icon: () => <PowerStandbyIcon />, handler: params => powerOrderBump(params) }
    ];

    const status =
      orderbump.ativo && !!orderbump.owner && !!orderbump.bump ? (
        <Typography style={{ color: '#009358', fontWeight: 'bold' }}>Ligado</Typography>
      ) : (
        <Typography style={{ fontWeight: 'bold' }}>Desligado</Typography>
      );

    return (
      <Grid key={orderbump.id} container className={expansionPanel}>
        <Grid xs={1} item>
          {status}
        </Grid>
        <Grid xs={5} item>
          <ProductInfo product={orderbump.owner} />
        </Grid>
        <Grid xs={5} item>
          <ProductInfo product={orderbump.bump} />
        </Grid>
        <Grid xs={1} container item justify="flex-end">
          <DropdownMenu options={options} object={orderbump} />
        </Grid>
      </Grid>
    );
  }
}
